import { connect } from 'react-redux';
import { getCurrentProject, getCurrentTicket } from 'Actions/ticketActions';
import { normalize, schema } from 'normalizr';
import {
  Grid,
  FormControl,
  Input,
  TextField,
  Divider,
} from '@material-ui/core';
import React from 'react';

import 'CSS/dashboard-slips.scss';
import 'CSS/dashboard-statistic.scss';
import 'CSS/dashboard-tickets.scss';
import 'CSS/demand-supply/demand-supply.scss';
import compact from 'lodash.compact';
import pick from 'lodash.pick';
import values from 'lodash.values';

import {
  getCurrentSlip,
  putSlipState,
  discardCurrentSlip,
  shortlistCurrentSlip,
  rateCurrentSlip,
  rateSlipUpdatedReset,
  addQuantitiesToCurrentSlip,
  getCircularEconomy,
} from 'Actions/slipActions';
import { getUsersInvited, getProjects } from 'Actions/projectActions';

import SealDealSubHeader from 'Demand/Demand/screens/components/SubHeaders/SealDealSubHeader';
import { CheckList } from './components/CheckList';
import { Comment } from './components/Comment';
import { ContactDetails } from './components/ContactDetails';
import IesFile from './components/IesFile';
import Quotation from './components/Quotation';
import { Notes } from './components/Notes';
import Photos from './components/Photos';
import RateAnswer from './components/RateAnswer';
import SpecificationSheets from './components/SpecificationSheets';
import Atachments from './components/Atachments';
import { SupplyNote } from './components/SupplyNote';
import SupplyPhoto from './components/SupplyPhoto';
import { Url } from './components/Url';
import { AddQuantities } from './components/AddQuantities';
import { ProjectDetails } from './components/ProjectDetails';
import { ArupContactDetails } from './components/ArupContactDetails';
import { Formik } from 'formik';
import DoneIcon from '@material-ui/icons/Done';
import generateValidationSchema from './formSchema';
// import Success from 'Components/Success';
import DiscardSlipDialog from './components/DiscardSlipDialog';
import axios from 'Axios';

import Button from '@material-ui/core/Button';

import styled from 'styled-components';
import { rhythm } from 'Themes/typography';
import Paper from '@material-ui/core/Paper';
import Section from './components/Section';
import SettingsGrid from './components/SettingsGrid';
import SpecificationItem from './components/SpecificationItem';
import NoteAndUrl from './components/NoteAndUrl';
import AddPhoto from './components/AddPhoto';
import logo from 'Images/logo.png';
import DealDialog from './components/DealDialog';
import NavigateBetweenSlips from './components/NavigateBetweenSlips';
import { AccountCircle } from '@material-ui/icons';
import { API_ROOT } from '../../../../../../src/api/Routes';

const TitleLeft = styled.h1`
  font-size: 1rem;
  float: left;
`;
const TitleRight = styled.h1`
  font-size: 1rem;
  float: right;
  margin-bottom: ${rhythm(1)};
`;
const JobNo = styled.h1`
  font-size: 1rem;
`;
const Clear = styled.div`
  clear: both;
`;

const PaperSheet = styled(Paper)`
  margin-top: ${rhythm(0.5)};
  padding: ${rhythm(0.1)} ${rhythm(0.8)} ${rhythm(0.5)} ${rhythm(0.8)};
  margin-bottom: ${rhythm(0.5)};
  width: 100%;
`;

const PaperSheetFrame = styled(Paper)`
  margin-top: ${rhythm(0.5)};
  padding: ${rhythm(0.1)} ${rhythm(0.8)} ${rhythm(0.5)} ${rhythm(0.8)};
  margin-bottom: ${rhythm(0.5)};
`;
const FooterSheetLeft = styled(Grid)`
  border-left: 1px solid #999a9a;
  display: flex;
  align-items: center;
`;
const SpecLeft = styled(Grid)`
  border-right: 1px solid #999a9a;
  margin: 5px 0 !important;
`;
const FooterArup = styled(Grid)`
  position: relative;
  display: flex;
  align-items: center;
  & h2 {
    margin: 0;
  }
  & p {
    font-size: 14px;
    margin: 0;
  }
`;
const DownloadButton = styled(Button)`
  background-color: white !important;
`;
const FooterSheetRight = styled(Grid)`
  border-left: 1px solid #999a9a;
`;

const SpecificationSheetFooter = styled(Grid)`
  margin-top: ${rhythm(0.3)} !important;
  margin-bottom: ${rhythm(0.3)} !important;
`;
const SpecInputsFooiter = styled(Grid)`
  display: flex;
  justify-content: center;
  flex-direction: column; /* column | row */
`;

const ArupInfo = styled(Grid)`
  align-items: center;
  display: flex;
`;

const PaperSize = styled.div`
  max-width: 1024px;
`;

const H4NoMargin = styled.h4`
  text-align: right;
  margin: 0;
`;

const H1NoMargin = styled.h1`
  color: hsla(0, 0%, 0%, 0.8) !important;
  padding-bottom: 0;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  color: inherit;
  font-family: 'Helvetica', 'Arial', sans-serif;
  font-weight: bold;
  text-rendering: optimizeLegibility;
  font-size: 2.3vmin;
  line-height: 1.1;
  margin: 0;
`;
const ArupLogo = styled.img`
  margin: 0;
  width: 110px;
`;
const UpdateMsg = styled.div`
  color: #f44336;
  padding: ${rhythm(0.5)} 0;
  max-width: 1024px;
  text-align: justify;
`;

class SingleSlip extends React.Component {
  state = {
    rated: 0,
    rateError: false,
    comment: '',
    quantities: '',
    unit: '',
    projectDetails: this.props.currentProject.confidential ? false : true,
    tabValue: 0,
    newProjectDialogOpen: false,
    hasProjects: true,
    entities: {},
    result: [],
    part2: false,
    deleteDialog: false,
    specificationSheetValue: {},
    luminaireImage: 1,
    polarDiagramImage: 1,
    dimensionsImage: 1,
    supplierContact: {},
    dealDialog: false,
    dealExistsDialog: false,
    unhandshakeDialog: false,
    shortlisted: false,
    circularEconomy: [],
    menuQuestions: {},
    multipleQuestions: {},
    generatedTextField: false,
    generatedTextValues: {},
    multipleQuestionsId: [],
    textFieldValues: {},
    demandCompanyInfo: {},
    specSheetLogoPreivew: null,
    specSheetLogo: null,
  };

  openDeleteDialog = () => {
    this.setState({ deleteDialog: true });
  };

  selectShortlist = values => () => {
    this.setState({
      shortlisted: true,
      comment: values.comment,
      rated: values.rating,
    });
  };

  deselectShortlist = values => () => {
    this.setState({
      shortlisted: false,
      comment: values.comment,
      rated: values.rating,
    });
  };

  closeDeleteDialog = () => {
    this.setState({ deleteDialog: false });
  };
  openDealDialog = () => {
    this.setState({ dealDialog: true });
  };
  closeDealDialog = () => {
    this.setState({ dealDialog: false });
  };
  openDealExistsDialog = () => {
    this.setState({ dealExistsDialog: true });
  };
  closeDealExistsDialog = () => {
    this.setState({ dealExistsDialog: false });
  };
  openUnhandshakeDialog = () => {
    this.setState({ unhandshakeDialog: true });
  };
  closeUnhandshakeDialog = () => {
    this.setState({ unhandshakeDialog: false });
  };

  setCircularEconomy = () => {
    let localCircularEconomy = [...this.props.currentEcon];
    this.setState({
      circularEconomy: [...localCircularEconomy],
    });
  };

  componentDidMount() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    const { projectId, ticketId, slipId } = this.props.match.params;

    axios.put(`slip/${slipId}/demand/change_slip_state`).then(res => {
      if (res.status === 200) {
        this.props.setCurrentProjectId(projectId);
        this.props.getCurrentSlip(slipId, projectId);
        this.props.setCurrentTicketId(ticketId);
        this.props.getCurrentTicket(projectId, ticketId);
        this.props.getCircularEconomy(slipId);
      }
    });

    if (Object.keys(this.props.currentSlip).length > 0) {
      this.setCriteria(this.props.currentSlip.criteria);
      this.props.currentSlip.specificationSheetValue &&
        this.setSpecificationSheet(
          this.props.currentSlip.specificationSheetValue
        );
      this.setSupplierContact(this.props.currentSlip.supplierContact);
      this.setSheetImages(
        this.props.currentSlip.luminaireImage,
        this.props.currentSlip.polarDiagramImage,
        this.props.currentSlip.dimensionsImage
      );
    }
    this.setState({ shortlisted: this.props.currentSlip.shortlisted });
  }

  navigateToSlip = slipId => {
    this.props.getCurrentSlip(slipId);

    if (Object.keys(this.props.currentSlip).length > 0) {
      this.setCriteria(this.props.currentSlip.criteria);

      this.props.currentSlip.specificationSheetValue &&
        this.setSpecificationSheet(
          this.props.currentSlip.specificationSheetValue
        );
      this.setSupplierContact(this.props.currentSlip.supplierContact);
      this.setSheetImages(
        this.props.currentSlip.luminaireImage,
        this.props.currentSlip.polarDiagramImage,
        this.props.currentSlip.dimensionsImage
      );
    }

    this.setState({ shortlisted: this.props.currentSlip.shortlisted });

    axios.put('slip/' + slipId + '/demand/change_slip_state').then(
      () => this.props.getProjects(),
      error => {
        console.log(error);
      }
    );
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      (prevProps.match.params.slipId !== this.props.match.params.slipId &&
        Object.keys(this.props.currentSlip).length > 0) ||
      (Object.keys(this.props.currentSlip).length > 0 &&
        Object.keys(prevProps.currentSlip).length === 0)
    ) {
      this.setCriteria(this.props.currentSlip.criteria);
      this.setCircularEconomy();
      this.props.currentSlip.specificationSheetValue &&
        this.setSpecificationSheet(
          this.props.currentSlip.specificationSheetValue
        );
      this.setSupplierContact(this.props.currentSlip.supplierContact);
      this.setSheetImages(
        this.props.currentSlip.luminaireImage,
        this.props.currentSlip.polarDiagramImage,
        this.props.currentSlip.dimensionsImage
      );
    }
    if (
      this.props.currentSlip.ratingComment !==
      prevProps.currentSlip.ratingComment
    ) {
      this.setState({
        part2: true,
        rated:
          this.props.currentSlip.rating === null
            ? 0
            : this.props.currentSlip.rating,
        // comment: this.props.currentSlip.ratingComment,
        quantities: this.props.currentSlip.quantityValue,
        unit: this.props.currentSlip.quantityUnit,
        projectDetails: this.props.currentSlip.shortlisted
          ? this.props.currentSlip.projectInfoVisible
          : this.props.currentProject.confidential
          ? false
          : true,
        shortlisted: this.props.currentSlip.shortlisted,
      });
    }
  }
  setCriteria = criteria => {
    this.setState(this.normalizeData(criteria));
  };

  setSpecificationSheet = specificationSheetValue => {
    specificationSheetValue = {
      manufacturer: this.props.currentSlip.supplierContact.manufacturer,
      ...specificationSheetValue,
    };
    this.setState({ specificationSheetValue });
  };
  setSheetImages = (luminaireImage, polarDiagramImage, dimensionsImage) => {
    this.setState({
      luminaireImage,
      polarDiagramImage,
      dimensionsImage,
    });
  };
  setSupplierContact = supplierContact => {
    this.setState({ supplierContact });
  };
  normalizeData = data => {
    const node = new schema.Entity('criteria');
    node.define({
      criteria: [node],
    });
    const treeSchema = [node];

    const normalized = normalize(data, treeSchema);

    return {
      entities: normalized.entities.criteria,
      result: normalized.result,
    };
  };
  handleChange = name => event => {
    if (name === 'confidential') {
      this.setState({ [name]: event.target.checked });
    } else {
      this.setState({ [name]: event.target.value });
    }
  };

  handleSlipChange = state => {
    this.setState({ projectInfoVisible: state });
  };

  setRate = setFieldValue => rate => () => {
    setFieldValue('rating', rate);
  };
  setProjectInfoVisibility = (visibility, setFieldValue) => () => {
    setFieldValue('projectInfoVisible', !visibility);
  };

  submitForm = data => {
    const values = {
      rating: data.rating,
      ratingComment: btoa(encodeURI(data.comment)),
    };
    const isShortlisted = this.state.shortlisted;
    if (this.props.currentSlip.shortlisted !== this.state.shortlisted) {
      if (this.state.shortlisted) {
        this.props.shortlistCurrentSlip(
          this.props.match.params.slipId,
          {
            ...values,
            quantityValue: data.quantityValue,
            quantityUnit: data.quantityUnit,
            projectInfoVisible:
              this.state.projectInfoVisible !== undefined
                ? this.state.projectInfoVisible
                : data.projectInfoVisible,
          },
          isShortlisted,
          this.props.history,
          this.props.match.params.ticketId,
          this.props.match.params.projectId
        );
      } else {
        this.props.shortlistCurrentSlip(
          this.props.match.params.slipId,
          values,
          isShortlisted,
          this.props.history,
          this.props.match.params.ticketId,
          this.props.match.params.projectId
        );
      }
    } else if (!this.state.shortlisted) {
      this.props.rateCurrentSlip(
        this.props.match.params.slipId,
        values,
        this.props.history,
        this.props.match.params.ticketId,
        this.props.match.params.projectId
      );
    } else {
      this.props.addQuantitiesToCurrentSlip(
        this.props.match.params.slipId,
        {
          ...values,
          quantityValue: data.quantityValue,
          quantityUnit: data.quantityUnit,
          projectInfoVisible:
            this.state.projectInfoVisible !== undefined
              ? this.state.projectInfoVisible
              : data.projectInfoVisible,
          specSheetLogoPreivew: this.state.specSheetLogoPreivew,
        },
        this.props.history,
        this.props.match.params.ticketId,
        this.props.match.params.projectId
      );
    }
  };

  getSpecificationSheetsLogo(data) {
    if (!data) return [];
    return compact(values(pick(data, ['logo'])));
  }

  getSpecificationSheets(data) {
    if (!data) return [];
    return compact(values(pick(data, ['file1', 'file2', 'file3'])));
  }
  getAtachments(data) {
    if (!data) return [];
    return compact(
      values(
        pick(data, [
          'attachmentFile1',
          'attachmentFile2',
          'attachmentFile3',
          'attachmentFile4',
          'attachmentFile5',
          'attachmentFile6',
          'attachmentFile7',
        ])
      )
    );
  }
  getSupplyPhotos(data) {
    if (!data) return [];
    return compact(values(pick(data, ['image1Id', 'image2Id', 'image3Id'])));
  }

  setInitialFormValues = data => {
    if (!data) return;
    let initialState = {
      comment: this.state.comment,
      //  ovo je izmenjenbo zbog dodavanja noveog komentara svaki put
      // comment: '',
      rating: data.rating
        ? data.rating !== this.state.rated
          ? this.state.rated
          : data.rating
        : this.state.rated,
    };
    if (!this.state.shortlisted) {
      return initialState;
    } else {
      initialState = {
        ...initialState,
        quantityValue: data.quantityValue ? data.quantityValue : '',
        quantityUnit: data.quantityUnit ? data.quantityUnit : '',
        projectInfoVisible: this.state.projectDetails,
      };
      return initialState;
    }
  };

  makeDeal = () => {
    axios.put('slip/' + this.props.match.params.slipId + '/demand/deal').then(
      response => {
        if (response.data) {
          if (response.data === -1) {
            this.closeDealDialog();
            this.openDealExistsDialog();
          } else {
            this.navigateToTicketSlips();
          }
        }
      },
      error => {
        console.error(error);
      }
    );
  };

  navigateToTicketSlips = () => {
    this.props.history.push(
      '/demand/project/' +
        this.props.currentProject.projectId +
        '/ticket/' +
        this.props.currentTicket.ticketId +
        '/slips'
    );
  };

  makeDealOnExistsDeals = () => {
    axios
      .put('slip/' + this.props.match.params.slipId + '/demand/deal/confirm')
      .then(
        response => {
          if (response.data) {
            this.navigateToTicketSlips();
          }
        },
        error => {
          console.error(error);
        }
      );
  };

  handleChangeLogo = event => {
    const image = event.target.files[0];

    const reader = new FileReader();

    reader.onload = readEvent => {
      const base64String = readEvent.target.result;
      this.setState({
        specSheetLogoPreivew: base64String,
      });

      const slipId = this.props.match.params.slipId;
      const data = new FormData();
      data.append('logo', image);

      axios.post(`/slip/${slipId}/logo`, data, {
        withCredentials: true,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    };

    reader.readAsDataURL(image);
  };

  downloadSpecSheet = () => {
    axios({
      url: 'zip/spec_sheet/' + this.props.match.params.slipId,
      method: 'GET',
      responseType: 'blob', // important
    }).then(
      response => {
        if (response.data) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'SpecificationSheet.zip'); //or any other extension
          document.body.appendChild(link);
          link.click();
        }
      },
      error => {
        console.error(error);
      }
    );
  };

  handleUnhandshake = () => {
    axios
      .put(`/slip/${this.props.currentSlip.id}/demand/undeal`)
      .then(() => {
        this.navigateToTicketSlips();
      })
      .catch(error => console.error(error));
  };
  disableSubmitIfIsDeactivated = () => {
    return this.props.currentSlip.attentionText ===
      'This user has been deactivated permanently, thus you cannot respond to this slip anymore'
      ? true
      : false;
  };

  disableSubmitIfIsDeactivated = () => {
    return this.props.currentSlip.attentionText ===
      'This user has been deactivated permanently, thus you cannot respond to this slip anymore'
      ? true
      : false;
  };

  renderSlip() {
    const getSheetLogoSrc = `${API_ROOT}/asset/${
      this.getSpecificationSheetsLogo(this.props.currentSlip)[0]
    }`;
    return (
      <PaperSize>
        <PaperSheetFrame>
          <CheckList
            criteria={this.state.entities}
            mainCriteria={this.state.result}
          />
          <div className="spacer-2" />
          <Grid container spacing={0}>
            <Photos assets={this.props.currentTicket.assets} />
            <Notes note={this.props.currentTicket.note} />
          </Grid>
          {this.state.circularEconomy.length !== 0 && (
            <div>
              <h2 className="t-primary-16 t-weight-b u-mrg-bot-3 u-mrg-top-20">
                Circular Economy Assessment
              </h2>
            </div>
          )}
          {this.state.circularEconomy &&
            this.state.circularEconomy.map(group => (
              <Grid item className="u-pad-bot-30">
                <Grid
                  item
                  className="t-primary-15 t-weight-b u-mrg-bot-3 u-mrg-top-20"
                >
                  <em>{group.text}</em>
                </Grid>
                {group.questions.map(question => (
                  <Grid container>
                    <Grid className="t-primary-13 t-weight-b u-mrg-bot-3 u-mrg-top-20 w50">
                      {question.text}
                    </Grid>
                    {question.questionType === 'PULL_DOWN_MENU' && (
                      <Grid
                        item
                        className="c-gray-light t-primary-13 u-mrg-left-100 u-mrg-top-10 menuItem"
                      >
                        <div className="u-mrg-bot-5">
                          {question.answers.map(answer => answer.text)}
                        </div>
                      </Grid>
                    )}
                    {question.questionType === 'PULL_DOWN_MENU_MULTISELECT' && (
                      <Grid
                        item
                        className="c-gray-light t-primary-13 u-mrg-left-100 u-mrg-top-10 menuItem"
                      >
                        {question.answers.map(answer => (
                          <div className="u-mrg-bot-5">
                            {answer.text}
                            {answer.answerValue && (
                              <p>
                                <TextField
                                  multiline
                                  fullWidth
                                  rowsMax={5}
                                  className="autoHeightComponent"
                                  disabled
                                  value={answer.answerValue}
                                />
                              </p>
                            )}
                          </div>
                        ))}
                      </Grid>
                    )}
                    {question.questionType === 'DIRECT' && (
                      <Grid
                        item
                        className="c-gray-light t-primary-13 u-mrg-left-100 u-mrg-top-10 menuItem"
                      >
                        {question.answers.map(answer => (
                          <div className="u-mrg-bot-5">
                            {answer.text}
                            {answer.answerValue && (
                              <p>
                                <TextField
                                  multiline
                                  fullWidth
                                  rowsMax={5}
                                  className="autoHeightComponent"
                                  disabled
                                  value={answer.answerValue}
                                />
                              </p>
                            )}
                          </div>
                        ))}
                      </Grid>
                    )}
                  </Grid>
                ))}
                <Divider className="u-mrg-top-10 u-mrg-bot-10" />
              </Grid>
            ))}
        </PaperSheetFrame>
        <Grid
          container
          className={'border-bottom-light-gray-2 border-top-light-gray-2'}
        >
          <Grid item md={12} className={'border-bottom-light-gray-2'}>
            <SupplyPhoto
              photos={this.getSupplyPhotos(this.props.currentSlip)}
            />
          </Grid>
          <Grid item md={12} lg={6}>
            <Grid
              container
              // alignContent="space-between"
              className="height-100p"
            >
              <SpecificationSheets
                files={this.getSpecificationSheets(this.props.currentSlip)}
              />
              <Atachments files={this.getAtachments(this.props.currentSlip)} />
            </Grid>
          </Grid>
          <Grid
            item
            md={12}
            lg={
              !this.getSpecificationSheets(this.props.currentSlip).length &&
              !this.props.currentSlip.ies
                ? 12
                : 6
            }
            className="pTopLeftRight-8"
          >
            <Grid
              container
              alignContent="space-between"
              className="height-100p  "
            >
              <IesFile ies={this.props.currentSlip.ies} />
              {this.props.currentSlip &&
              this.props.currentSlip.shortlisted &&
              (this.props.currentSlip.slipState === 'RESPONDED' ||
                this.props.currentSlip.slipState === 'DEAL') ? (
                <Quotation ies={this.props.currentSlip.quotation} />
              ) : null}
              <Url url={this.props.currentSlip.url} />
              <ContactDetails
                contactDetails={this.props.currentSlip.supplierContact}
              />
            </Grid>
          </Grid>
        </Grid>
        <Formik
          validateOnBlur={false}
          enableReinitialize
          validationSchema={
            // this.props.currentSlip.shortlisted
            this.state.shortlisted
              ? generateValidationSchema(2)
              : generateValidationSchema(1)
          }
          initialValues={this.setInitialFormValues(this.props.currentSlip)}
          onSubmit={this.submitForm}
        >
          {({
            handleChange,
            handleBlur,
            handleReset,
            errors,
            values,
            touched,
            handleSubmit,
            setValues,
            setFieldValue,
          }) => {
            return (
              <div>
                {this.props.currentSlip &&
                this.props.currentSlip.shortlisted &&
                (this.props.currentSlip.slipState === 'RESPONDED' ||
                  this.props.currentSlip.slipState === 'DEAL') ? (
                  <Grid container>
                    <PaperSheet elevation={5}>
                      <Section>
                        <div>
                          <TitleLeft>
                            Project Title:
                            {this.props.currentProject &&
                              ' ' + this.props.currentProject.name}
                          </TitleLeft>
                          <TitleRight>Luminaire Specification Sheet</TitleRight>
                        </div>

                        <Clear> </Clear>
                        <JobNo>
                          Job No.:
                          {this.props.currentProject &&
                            ' ' + this.props.currentProject.uniqueProjectNumber}
                        </JobNo>
                        <div className="spacer-2" />
                        <SettingsGrid>
                          {Object.entries(
                            this.state.specificationSheetValue
                          ).map(item => {
                            let result = '';
                            let words = '';
                            if (item[0] !== 'protectionRatingIk') {
                              result = item[0].replace(/([A-Z])/g, ' $1');
                              words =
                                result.charAt(0).toUpperCase() +
                                result.slice(1);
                            } else {
                              words = 'Protection Rating IK';
                            }
                            return (
                              <SpecificationItem
                                name={`specificationSheetValue.${item[0]}`}
                                key={item[0]}
                                title={words}
                                value={
                                  this.state.specificationSheetValue[item[0]]
                                    ? this.state.specificationSheetValue[
                                        item[0]
                                      ]
                                    : ''
                                }
                                unit={
                                  this.props.currentSlip.specificationSheet[
                                    item[0]
                                  ]
                                    ? this.props.currentSlip.specificationSheet[
                                        item[0]
                                      ].unit
                                      ? this.props.currentSlip
                                          .specificationSheet[item[0]].unit
                                      : ''
                                    : ''
                                }
                              />
                            );
                          })}
                        </SettingsGrid>
                        <div className="spacer-2" />
                      </Section>
                      <Grid
                        container
                        spacing={16}
                        // className={ 'takeFreeSpace' }
                      >
                        <SpecLeft item xs={12} md={8}>
                          <AddPhoto
                            photo={this.state.luminaireImage}
                            photo1={this.state.polarDiagramImage}
                            photo2={this.state.dimensionsImage}
                          />
                        </SpecLeft>
                        <Grid item xs={12} md={4}>
                          <NoteAndUrl
                            generalNotes={this.props.currentSlip.generalNotes}
                            notes={this.props.currentSlip.slipNote}
                            note={values.slipNote}
                            url={values.url}
                            details={this.state.supplierContact}
                          />
                        </Grid>
                      </Grid>

                      <div className="spacer-2" />
                      <SpecificationSheetFooter
                        container
                        spacing={16}
                        alignItems="stretch"
                      >
                        <ArupInfo item xs={12} md={4}>
                          <Grid container>
                            <FooterArup item xs={12} md={12} lg={5}>
                              {this.props.currentSlip.demandContact.company ===
                              'arup' ? (
                                <ArupLogo src={logo} />
                              ) : (
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    gap: '10px',
                                  }}
                                >
                                  {this.state.specSheetLogoPreivew ||
                                  this.props.currentSlip.logo ? (
                                    <div
                                      style={{
                                        maxWidth: '120px',
                                        overflow: 'hidden',
                                      }}
                                    >
                                      <img
                                        src={
                                          this.state.specSheetLogoPreivew
                                            ? this.state.specSheetLogoPreivew
                                            : getSheetLogoSrc
                                        }
                                        style={{
                                          display: 'block',
                                          width: '100%',
                                          objectFit: 'contain',
                                        }}
                                      />
                                    </div>
                                  ) : (
                                    <AccountCircle
                                      style={{
                                        fontSize: '55px',
                                        margin: 'auto',
                                      }}
                                      className="editProfileAvatar"
                                    />
                                  )}
                                  <label htmlFor="add-logo">Add Logo</label>
                                  <input
                                    id="add-logo"
                                    type="file"
                                    style={{
                                      cursor: 'pointer',
                                      position: 'absolute',
                                      display: 'block',
                                      width: '100%',
                                      height: '100%',
                                      opacity: '0',
                                    }}
                                    onChange={this.handleChangeLogo}
                                  />
                                </div>
                              )}
                            </FooterArup>
                            <FooterArup item xs={12} md={12} lg={7}>
                              <div style={{ margin: '0 5px' }}></div>
                              <div>
                                <p>
                                  {this.props.currentSlip.demandContact
                                    .company &&
                                    this.props.currentSlip.demandContact
                                      .company}
                                  ,{' '}
                                  {this.props.currentSlip.demandContact.address}
                                </p>
                                {/* <p>Postalcode</p> */}
                              </div>
                            </FooterArup>
                          </Grid>
                        </ArupInfo>
                        <FooterSheetLeft item xs={12} md={6}>
                          <Grid container>
                            <SpecInputsFooiter item md={4}>
                              <H4NoMargin> Purpose of Issue:</H4NoMargin>
                            </SpecInputsFooiter>
                            <Grid item md={8}>
                              <Input className={'mLeft-5'} />
                            </Grid>
                            <SpecInputsFooiter item md={4}>
                              <H4NoMargin>Date/Revision: </H4NoMargin>
                            </SpecInputsFooiter>
                            <Grid item md={8}>
                              <Input className={'mLeft-5'} />
                            </Grid>
                          </Grid>
                        </FooterSheetLeft>
                        <FooterSheetRight item xs={12} md={2}>
                          <b>Type:</b>
                          <H1NoMargin>
                            {this.props.currentTicket.referenceName}
                          </H1NoMargin>
                        </FooterSheetRight>
                      </SpecificationSheetFooter>
                    </PaperSheet>
                  </Grid>
                ) : null}

                {this.props.currentSlip &&
                this.props.currentSlip.shortlisted &&
                (this.props.currentSlip.slipState === 'RESPONDED' ||
                  this.props.currentSlip.slipState === 'DEAL') ? (
                  <DownloadButton
                    variant="contained"
                    color="primary"
                    className="t-weight-b criteria-button w300px"
                    onClick={this.downloadSpecSheet}
                  >
                    Download Specification Sheet
                  </DownloadButton>
                ) : null}

                <PaperSheetFrame>
                  <Grid container>
                    {/* <div className="spacer-2" /> */}

                    <SupplyNote
                      note={this.props.currentSlip.slipNote}
                      user={
                        this.props.currentUser.firstName +
                        ' ' +
                        this.props.currentUser.lastName
                      }
                    />
                    <Grid item xs={6}>
                      <RateAnswer
                        rated={values.rating}
                        setRate={this.setRate(setFieldValue, values.rating)}
                        error={errors}
                      />
                      <Comment
                        user={this.props.currentUser}
                        comment={values.comment}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        errors={errors}
                        touched={touched}
                      />
                    </Grid>
                  </Grid>
                  {/* {this.props.currentSlip &&
                this.props.currentSlip.shortlisted ? ( */}
                  {this.state.shortlisted ? (
                    <Grid container>
                      <div className="spacer-2" />
                      <AddQuantities
                        quantities={values.quantityValue}
                        unit={values.quantityUnit}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        errors={errors}
                        touched={touched}
                      />
                      <ProjectDetails
                        project={this.props.currentProject}
                        projectUsageArea={
                          this.props.projectUsages &&
                          this.props.projectUsages.projectBusinessArea &&
                          this.props.projectUsages.projectBusinessArea.find(
                            pu =>
                              pu.id ===
                              this.props.currentProject.projectUsageAreaId
                          )
                        }
                        projectUsageType={
                          this.props.projectUsages &&
                          this.props.projectUsages.projectType &&
                          this.props.projectUsages.projectType.find(
                            pu =>
                              pu.id ===
                              this.props.currentProject.projectUsageTypeId
                          )
                        }
                        projectInfoVisible={values.projectInfoVisible}
                        handleChange={this.handleSlipChange}
                        confidential={this.props.currentProject.confidential}
                        handleBlur={handleBlur}
                        errors={errors}
                        touched={touched}
                      />
                      {/* <ArupContactDetails
                      contactDetails={this.props.currentUser}
                    /> */}
                    </Grid>
                  ) : null}
                </PaperSheetFrame>

                <Grid
                  container
                  className="shortlist-discard flexblock"
                  justify="space-between"
                  alignContent="center"
                  alignItems="center"
                >
                  <Button
                    variant="contained"
                    color="primary"
                    className="t-weight-b criteria-button w300px"
                    disabled={this.disableSubmitIfIsDeactivated()}
                    onClick={handleSubmit}
                  >
                    Submit
                  </Button>

                  {this.props.currentSlip &&
                  (this.props.currentSlip.slipState === 'RESPONDED' ||
                    this.props.currentSlip.slipState === 'DEAL') ? (
                    <React.Fragment>
                      <Button
                        disabled={this.disableSubmitIfIsDeactivated()}
                        variant="contained"
                        className={
                          this.props.currentSlip.slipState === 'DEAL'
                            ? 't-weight-b u-mrg-5'
                            : 't-weight-b u-mrg-5'
                        }
                        onClick={
                          this.props.currentSlip.slipState === 'DEAL'
                            ? this.openUnhandshakeDialog
                            : this.openDealDialog
                        }
                      >
                        {this.props.currentSlip.slipState === 'DEAL'
                          ? 'Unhandshake'
                          : 'Handshake'}
                      </Button>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      {/* {this.props.currentSlip &&
                      this.props.currentSlip.shortlisted ? ( */}
                      {this.state.shortlisted ? (
                        <Button
                          variant="contained"
                          className="t-weight-b u-mrg-5 button--green"
                          // onClick={this.props.shortlistCurrentSlip(
                          //   this.props.match.params.slipId
                          // )}
                          onClick={this.deselectShortlist(values)}
                        >
                          <DoneIcon />
                          SHORTLISTED
                        </Button>
                      ) : (
                        <Button
                          color="secondary"
                          variant="outlined"
                          className="t-primary-16 u-mrg-5"
                          // onClick={this.props.shortlistCurrentSlip(
                          //   this.props.match.params.slipId
                          // )}

                          onClick={this.selectShortlist(values)}
                        >
                          Shortlist
                        </Button>
                      )}
                    </React.Fragment>
                  )}

                  <Button
                    className="c-gray-light t-weight-b u-mrg-5"
                    onClick={this.openDeleteDialog}
                    // onClick={this.props.print}
                  >
                    DISCARD
                  </Button>
                </Grid>
                <div className="u-mrg-top-30">
                  <DiscardSlipDialog
                    element={'Luminaire'}
                    doDelete={() => {
                      this.props.discardCurrentSlip(
                        this.props.match.params.slipId,
                        this.props.history,
                        this.props.match.params.ticketId,
                        this.props.match.params.projectId
                      );
                    }}
                    handleClose={this.closeDeleteDialog}
                    isOpen={this.state.deleteDialog}
                  />
                </div>
                <DealDialog
                  title={'Select Luminaire'}
                  action={this.makeDeal}
                  handleClose={this.closeDealDialog}
                  isOpen={this.state.dealDialog}
                  message={'Are you sure you want to select this Luminaire'}
                  buttonTxtConfirm={'Handshake'}
                />
                <DealDialog
                  title={'Select Luminaire'}
                  action={this.makeDealOnExistsDeals}
                  handleClose={this.closeDealExistsDialog}
                  isOpen={this.state.dealExistsDialog}
                  message={
                    'There is already a Luminaire in the Selections phase, are you sure you want to replace it with this Luminaire?'
                  }
                  buttonTxtConfirm={'Yes'}
                />
                <DealDialog
                  title={'Deselect Luminaire'}
                  action={this.handleUnhandshake}
                  handleClose={this.closeUnhandshakeDialog}
                  isOpen={this.state.unhandshakeDialog}
                  message={'Are you sure you want to deselect this Luminaire'}
                  buttonTxtConfirm={'Yes'}
                />
              </div>
            );
          }}
        </Formik>
      </PaperSize>
    );
  }
  render() {
    const ticketId = Number(this.props.match.params.ticketId);
    return (
      <Grid item className="flex-dashboard">
        <Grid container>
          <Grid item xs={12}>
            <SealDealSubHeader
              currentTicket={this.props.currentTicket}
              goBack={this.props.history.goBack}
              ticket={
                this.props.tickets
                  ? this.props.tickets.find(
                      ticket => ticket.ticketId === ticketId
                    )
                  : null
              }
              projectId={this.props.match.params.projectId}
              ticketId={this.props.match.params.ticketId}
              history={this.props.history}
            />
          </Grid>
          <Grid item xs={12} className="dash-padding">
            <UpdateMsg>
              {this.props.currentSlip.attentionText && (
                <h2>{this.props.currentSlip.attentionText}</h2>
              )}
            </UpdateMsg>
            <NavigateBetweenSlips
              history={this.props.history}
              getIt={this.navigateToSlip}
              slipIds={this.props.currentTicket.slipIds}
              slipId={Number(this.props.match.params.slipId)}
              projectId={this.props.match.params.projectId}
              ticketId={this.props.match.params.ticketId}
            />
            {this.renderSlip()}
          </Grid>
        </Grid>
      </Grid>
    );
  }
}
const mapStateToProps = store => {
  return {
    tickets: store.currentProject.tickets,
    currentTicket: store.currentProject.currentTicket,
    currentSlip: store.slips.currentSlip,
    currentEcon: store.slips.currentEcon,
    currentProject: store.currentProject.project,
    projectUsages: store.projects.projectUsages,
    currentUser: store.user.user,
    slipUpdateStatus: store.slips.updated,
    deletedTicket: store.currentProject.data,
  };
};
const mapDispatchToProps = dispatch => ({
  getProjects: () => {
    dispatch(getProjects());
  },
  getCurrentProject: projectId => {
    dispatch(getCurrentProject(projectId));
  },
  getUsersInvited: projectId => {
    dispatch(getUsersInvited(projectId));
  },
  getCurrentTicket: (projectId, ticketId) => {
    dispatch(getCurrentTicket(projectId, ticketId));
  },
  getCurrentSlip: (slipId, projectId) => {
    dispatch(getCurrentSlip(slipId, projectId));
  },
  getCircularEconomy: slipId => {
    dispatch(getCircularEconomy(slipId));
  },
  putSlipState: slipId => {
    dispatch(putSlipState(slipId));
  },
  shortlistCurrentSlip: (
    slipId,
    slipObject,
    shortlisted,
    history,
    ticketId,
    projectId
  ) => {
    dispatch(
      shortlistCurrentSlip(
        slipId,
        slipObject,
        shortlisted,
        history,
        ticketId,
        projectId
      )
    );
  },
  discardCurrentSlip: (slipId, history, ticketId, projectId) => {
    dispatch(discardCurrentSlip(slipId, history, ticketId, projectId));
  },
  rateCurrentSlip: (slipId, slipObject, history, ticketId, projectId) => {
    dispatch(rateCurrentSlip(slipId, slipObject, history, ticketId, projectId));
  },
  addQuantitiesToCurrentSlip: (
    slipId,
    slipObject,
    history,
    ticketId,
    projectId
  ) => {
    dispatch(
      addQuantitiesToCurrentSlip(
        slipId,
        slipObject,
        history,
        ticketId,
        projectId
      )
    );
  },
  resetSlipUpdate() {
    dispatch(rateSlipUpdatedReset());
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(SingleSlip);
